import React from 'react';
import { BarChart3Icon, SettingsIcon, TimerIcon } from 'lucide-react';
export type Screen = 'timer' | 'progress' | 'settings';
const TABS: {
  id: Screen;
  label: string;
  Icon: typeof TimerIcon;
}[] = [{
  id: 'timer',
  label: 'Timer',
  Icon: TimerIcon
}, {
  id: 'progress',
  label: 'Progress',
  Icon: BarChart3Icon
}, {
  id: 'settings',
  label: 'Settings',
  Icon: SettingsIcon
}];
interface BottomNavProps {
  active: Screen;
  onChange: (screen: Screen) => void;
}
export function BottomNav({
  active,
  onChange
}: BottomNavProps) {
  return <nav aria-label="Main" className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-bg/95 backdrop-blur" data-id="element-12" data-mp="2ooztuq8cimns">
      <ul className="mx-auto flex max-w-md items-stretch justify-around px-4 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-1.5" data-id="element-13" data-mp="2esd7fx0dfnjn">
        {TABS.map(({
        id,
        label,
        Icon
      }) => {
        const isActive = active === id;
        return <li key={id} className="flex-1" data-id="element-14" data-mp="d21rmgc982ob">
              <button type="button" onClick={() => onChange(id)} aria-current={isActive ? 'page' : undefined} className={`flex min-h-[48px] w-full flex-col items-center justify-center gap-1 rounded-xl text-[11px] font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral ${isActive ? 'text-ink' : 'text-muted hover:text-ink'}`} data-id="element-15" data-mp="cz77kpx5kjvf">
                <Icon size={20} strokeWidth={1.5} aria-hidden="true" data-id="element-16" data-mp="wo3vfnsqeaop" />
                {label}
              </button>
            </li>;
      })}
      </ul>
    </nav>;
}